export const css = {
	root: '_2ffUW8nF',
	input: '_1fTAOl6m',
	inputWrapper: 'bMFH9TsX _3X-56MuT _2h4NVjMB',
	checked: '_3Sma8IEj',
	focused: 'yGUGd8Oo',
	onLabel: '_3-KlALLQ',
	offLabel: '_18GqByXi',
	disabled: '_3Jz_uLFX',
	readonly: '_2siWCnyv',
	invalid: 'bIvbVgeJ',
	valid: '_2vGpc77t',
	' _key': 'apic-theme/apic/dojo/checkbox'
};

export default css;
